import { timezoneLookup } from 'utils/lookups';

/* eslint-disable */
export const preferencesSegmentData: any = [
  {
    "field_map": "timezone",
    "item_name": "timezone",
    "title": "Timezone",
    "hint_detail": "Timezone",
    "hint_panel" : "Timezone",
    "example": "",
    "sequence": 2,
    "show_more": true,
    "lookup": timezoneLookup,
  },
];
/* eslint-enable */
